import rootReducer from '../reducers';
import { applyMiddleware, createStore } from 'redux';

// Use redux-logger for logging state changes.
import createLogger from 'redux-logger';
const logger = createLogger();

// Use redux-thunk for dispatching actions from actions.
import thunk from 'redux-thunk';

// Use redux-promise-middleware for handling promise-based actions.
import promiseMiddleware from 'redux-promise-middleware';

export default (initialState) => {
  return createStore(rootReducer, initialState, applyMiddleware(thunk, promiseMiddleware(), logger));
};



// WEBPACK FOOTER //
// ./src/store/configure-store.js